<template>
  <div >
    <!--<div class="about-Our-banner" v-bind:style="{backgroundImage:'url(' + bg + ')',backgroundSize: 'cover',backgroundPosition: 'center',backgroundRepeat:'no-repeat'}">-->
      <!--<head-menu   fd="0"  current="6"></head-menu>-->
      <!--<img :src="bg" class="about-Our-banner-img" style="display:block;width: 100%;position: relative;z-index: -100">-->
    <!--</div>-->
    <div class="about-banner" v-bind:style="{backgroundImage:'url(' + bg + ')'
    ,backgroundPosition:'center',backgroundRepeat:'no-repeat',backgroundSize: 'cover'}">
      <head-menu   fd="0"  current="6"></head-menu>
      <img  :src="bg" class="about-banner-img" style="width: auto;height:auto;max-width: 100%;max-height:99%">
    </div>

    <div class="about-our-height" style="max-width:1210px;padding-bottom:40px;background-color: #fff;margin: 0 auto;top: -50px;position: relative;box-shadow:0px 2px 32px 0px rgba(0, 0, 0, 0.29);;-moz-box-shadow:0 0 8px #DDD;-webkit-box-shadow:0 0 8px #DDD;">
     <!--<div style="font-size:22px;color:rgba(0,0,0,1);text-align: center;padding-top:42px " >关于我们</div>-->

      <el-row class="show-about-our-head-tlie2" style="margin-top: 20px">
        <el-col :lg="{span:10,offset:0}" :md="{span:8,offset:0}" :xs="24" style="margin-top: 70px">
          <div style="width: 98%;height: 1px;background-color:rgb(229, 229, 229);margin-top: 20px;" ></div>
        </el-col>
        <el-col :lg="{span:14,offset:0}" :md="{span:16,offset:0}" :xs="24"  style="margin-top: 70px" >
          <h3 style="font-weight: bold;border-bottom:1px solid #e5e5e5;padding-bottom: 10px;font-size: 40px;width: 99%;margin-left: 1%">
            <span style="border-bottom: 2px solid #083A6F;padding-bottom: 10px;font-family:Microsoft YaHei">About Us</span>
          </h3>
          <!--<div  style="font-size:22px;color:rgba(8,58,111,1);margin-top: 10px;text-align: left;width: 99%;margin-left: 1%;color: #666666">道远资本&nbsp;&nbsp;<span style="color: #083A6F;font-size: 30px">关于我们</span></div>-->

          <div  style="font-size:30px;color:rgba(8,58,111,1);margin-top: 10px;text-align: left;width: 99%;margin-left: 1%;color: #083A6F;font-family:Microsoft YaHei">&nbsp;&nbsp;&nbsp;&nbsp;关于我们</div>
        </el-col>
      </el-row>

      <div  class="about-top"></div>
      <div  style="text-align:center;font-weight: bold;padding-bottom: 10px;font-size: 2em;border-bottom:1px solid #e5e5e5;font-family:Microsoft YaHei" class="show-about-our-head-tlie">About Us</div>
      <div class="show-about-our-head-tlie"  style="font-size:22px;color:rgba(8,58,111,1);margin-top: 10px;text-align: center;margin-bottom: 20px;font-family:Microsoft YaHei">关于我们</div>

      <!--<div style="width:35px;height:4px;background:rgba(8,58,111,1);margin: 0 auto;margin-top: 20px"></div>-->
      <el-row   style="margin-top: 45px">
      <el-col :lg="{span:8,offset:0}" :sm="{span:10,offset:0}" :md="{span:10,offset:0}" :xs="{span:0,offset:0}">
        <img style="width: 320px;" class="about-our-time" :src="imgx">
      </el-col>
      <el-col :lg="{span:14,offset:1}" :sm="{span:10,offset:4}" :md="{span:12,offset:2}" :xs="{span:20,offset:2}" stlye="text-align: justify">
        <div v-if="language == 'CN'" style="margin-top: 21px;font-size: 14px">
        <span style="margin-top: 16px;line-height: 26px"><span style="color: #083A6F;font-weight:bold;">使命：道远资本</span>是专注于医疗健康行业的新锐投资机构，致力于用资本的力量和产业资源帮助优秀医疗健康企业快速成长，为社会提供更好的医疗产品和服务，增进人类健康。</span>
        <br>
        <span style="line-height: 30px"><span style="color: #083A6F;font-weight:bold;" >产业：</span>我们的投资范围包括制药、医疗器械、生物技术、医疗服务和数字医疗等各细分领域，涵盖了初创、成长、成熟期等企业成长的各个阶段。</span>
        <br>
        <span style="line-height: 30px"><span style="color: #083A6F;font-weight:bold;">能力：</span>我们的投资团队成员来自于知名投资机构、医药器械企业和科研机构，拥有丰富的产业经验和投资经验，善于识别和挖掘医疗健康行业的投资机会。</span>
        <br>
        <span style="line-height: 30px"><span style="color: #083A6F;font-weight:bold;">成果：</span>道远资本创立于2014年，2019年有5家企业实现在港股和科创板上市，预计未来2年内还会有超过10家投资企业在国内外主要证交所上市。</span>
          <br>
          <span style="line-height: 30px"><span style="color: #083A6F;font-weight:bold;">声誉：</span>道远资本以其广泛充沛的项目资源、深入细致的尽职调查、专业精准的项目判断、灵活高效的股权交易技能受到被投资企业、业界同行和有限合伙出资人的广泛赞誉。</span>
        <br>
        <span style="line-height: 30px; color: #083A6F;font-weight:bold;">道远资本目前管理9支人民币基金，1支美元基金，管理资金规模近30亿元人民币，投资项目共42个。</span>
        </div>
        <div v-if="language == 'EN'" style="margin-top: 21px;font-size: 14px">
        <span style="margin-top: 16px;line-height: 26px"><span style="color: #083A6F;font-weight:bold;">Mission:</span>Our mission is to provide better medical products and devices for society and enhance human health by helping outstanding healthcare companies grow rapidly with capital and industrial resources. </span>
        <br>
        <span style="line-height: 30px"><span style="color: #083A6F;font-weight:bold;" >Industry:</span>We invest in companies in pharmaceuticals, medical devices, biotechnology, medical services, and digital healthcare in different stages from seed to pre-IPO. </span>
        <br>
        <span style="line-height: 30px"><span style="color: #083A6F;font-weight:bold;">Team:</span>Our investment team members come from leading investment institutions, pharmaceutical and medical devices companies, and scientific research institutions with rich industrial and investment experience</span>
        <br>
        <span style="line-height: 30px"><span style="color: #083A6F;font-weight:bold;">IPOs:</span> Tao Capital was founded in 2014. Eleven companies have been listed on the Hong Kong Stock Market and the Science and Technology Innovation Board from 2019 to 2021, including Jinxin Fertility (01951. HK), Viva Biotech (01873. HK), Basecare (02170.HK), Clover Biopharmaceuticals (02197.HK), and so on. By the end of 2021, two other companies have passed the Listing Committee meeting of the Science and Technology Innovation Board and the Growth Enterprise Market (GEM), one enterprise has passed the hearing of the Hong Kong Stock Exchange, and two enterprises’ IPO applications were accepted. In addition, more than 10 investment companies are expected to list on major domestic and international stock exchanges in the next two years.</span>
          <br>
          <span style="line-height: 30px"><span style="color: #083A6F;font-weight:bold;">Reputation:</span>Tao Capital has been widely praised by portfolio companies, industry peers and limited partnership investors for its extensive project resources, in-depth due diligence, professional and accurate and thoughtful judgment, and flexible and efficient equity investment skills.</span>
        <br>
        <span style="line-height: 30px; color: #083A6F;font-weight:bold;">Tao Capital currently manages 12 RMB funds and 2 US dollar funds with about 3 billion RMB asset under management and 72 portfolio companies.</span>
        </div>
      </el-col>

      </el-row>
    </div>
    <!--<div  class="about-Our-banner2" style="width: 100%;top: -50px;position: relative" :style="{backgroundImage: 'url('+bgx+')',backgroundPosition: 'center',backgroundRepeat:'no-repeat'}">-->
      <!--<img :src="bgx" class="about-Our-banner-img" style="display:block;width: 100%;">-->
    <!--</div>-->

    <el-row  style="margin-top: 45px">
      <el-col :lg="{span:24,offset:0}" :sm="{span:24,offset:0}" :md="{span:24,offset:0}" :xs="{span:0,offset:0}">
        <img  :src="bgx"  style="width:100%; display:block;">
      </el-col>
      <el-col :lg="{span:0,offset:0}" :sm="{span:0,offset:0}" :md="{span:0,offset:0}" :xs="{span:24,offset:0}">
        <img  :src="phonebg"  style="width:100%; display:block;">
      </el-col>
    </el-row>

    <footee ></footee>
  </div>
</template>

<script>
  import HeadMenu from '../../share/head-mean'
  import footee from '../../share/footer.vue'
  export default {
    components:{
      "head-menu":HeadMenu,
      "footee":footee
    },
    name: "aboutOur",
    mounted(){
    if(localStorage.getItem('language')){
      this.language =localStorage.getItem('language')
    }else{
      this.language = 'CN'
    }
    },
    data(){
      return {
        phonebg: require('@/assets/aboutOur/phonebg.jpg'),
        language:'CN',
        bg: require('@/assets/aboutOur/banner1.jpg'),
        imgx:require('@/assets/aboutOur/1.jpg'),
        bgx:require('@/assets/aboutOur/banner2.jpg')
      }
    },
  }
</script>

<style scoped>
  .about-banner{
    height: 200px;
  }

  .about-foot-banner{
    height: 200px;
  }
  .about-foot-banner-img{
    display: none !important;
  }


  /deep/ .el-menu-item{
    padding: 0px;
  }
/deep/ .el-menu--horizontal>.el-menu-item.is-active{
  font-weight:bold;
  color:rgba(8,58,111,1);
  border-bottom: 0px;
}
  @media screen and (min-width: 750px) { /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
    .about-our-time {
      margin-left: 100px;
    }
    .about-top{
      height: 45px;
  }

  }


  @media screen and (max-width: 750px) { /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
    .about-top{
    height: 45px;
    }
  }

  @media screen and (max-width: 1210px) and ( min-width:750px){
    .show-about-our-head-tlie2{
      display: none;
    }

    .about-banner{
      background-image: none !important;
    }
  }
  @media screen and (min-width: 1210px){
    .show-about-our-head-tlie{
      display: none;
    }
    .about-top{
      height: 0px;
    }
    .about-Our-banner{
      height: 400px;
    }
    .about-Our-banner2{
      height: 269px;
    }
    .about-Our-banner-img{
      display: none !important;
    }
    .about-banner{
      height: 400px;
    }
    .about-banner-img{
      display: none !important;
    }
  }

  @media screen and (max-width: 760px){

    .show-about-our-head-tlie2{
         display: none;
       }

  }
</style>



// WEBPACK FOOTER //
// src/components/aboutOur/indexEN.vue